import React from "react";
import { TextField, useTheme } from "cayo.ui";
import styled from "styled-components";
import { InitialStateType } from "../types";
import { useIntl } from "react-intl";
import { wizardMessages } from "../messages";
import { MessageBar, MessageBarType } from "@fluentui/react";

type SpecifyCredentialsProps = {
  state: InitialStateType;
  dispatch: (data: any) => void;
  message?: string;
};

const SpecifyCredentials = ({ state, message, dispatch }: SpecifyCredentialsProps) => {
  const intl = useIntl();
  const { cayoTheme } = useTheme();
  const { name, password, user } = state?.credentials;

  return (
    <Wrapper>
      <MessageBar
        messageBarType={MessageBarType.info}
        truncated={true}
        styles={{
          root: {
            marginBottom: 20,
            background: cayoTheme.wizard.colors.active,
          },
        }}
      >
        {message ? message : intl.formatMessage(wizardMessages.specifyCredentialsMessage)}
      </MessageBar>
      <StyledTextField
        value={name}
        label={intl.formatMessage(wizardMessages.fieldForestName)}
        placeHolder={intl.formatMessage(wizardMessages.fieldForestNamePlaceholder)}
        required
        setValue={(value) => {
          dispatch({
            type: "update",
            payload: {
              form: "credentials",
              data: {
                name: value,
              },
            },
          });
        }}
      />
      <StyledTextField
        value={user}
        label={intl.formatMessage(wizardMessages.fieldAccountName)}
        placeHolder={intl.formatMessage(wizardMessages.fieldAccountNamePlaceholder)}
        required
        setValue={(value) => {
          dispatch({
            type: "update",
            payload: {
              form: "credentials",
              data: {
                user: value,
              },
            },
          });
        }}
      />
      <StyledTextField
        value={password}
        label={intl.formatMessage(wizardMessages.fieldPassword)}
        placeHolder={intl.formatMessage(wizardMessages.fieldPasswordPlaceholder)}
        required
        type="password"
        isConfidential
        setValue={(value) => {
          dispatch({
            type: "update",
            payload: {
              form: "credentials",
              data: {
                password: value,
              },
            },
          });
        }}
      />
    </Wrapper>
  );
};

const StyledTextField = styled(TextField)`
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

export default SpecifyCredentials;
